import { Logo } from "@/components/Logo";
import { Github, Twitter, Instagram } from "lucide-react";

export const Footer = () => {
    return (
        <footer className="pp-bg-0 border-t border-[#242436] py-8" data-testid="footer">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-2 text-[#b7b7c6]">
                    <Logo size={22} />
                    <span className="font-display tracking-widest text-white">HOTSLIP</span>
                    <span className="text-xs font-mono">© {new Date().getFullYear()}</span>
                </div>
                <div className="flex items-center gap-3 text-[#8b8ba0]">
                    <a href="#" className="hover:text-white" aria-label="Twitter"><Twitter className="w-4 h-4" /></a>
                    <a href="#" className="hover:text-white" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
                    <a href="#" className="hover:text-white" aria-label="GitHub"><Github className="w-4 h-4" /></a>
                </div>
                <p className="text-xs text-[#8b8ba0] font-mono uppercase max-w-md text-center md:text-right">For entertainment only. 21+. Please play responsibly.</p>
            </div>
        </footer>
    );
};
